/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LinkGlobeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Link Globe',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.748 28.057a8.007 8.007 0 0 1-.822-.232c-.52.52-1.5 1.547-1.713 1.762a4.1 4.1 0 1 1-5.8-5.8L13.6 16.6a4.585 4.585 0 0 1 3.366-1.292 3.939 3.939 0 0 1 2.678 1.112 6.6 6.6 0 0 1 .439.51 12.264 12.264 0 0 1 2.553-1.319 6.847 6.847 0 0 0-.951-1.233 7.311 7.311 0 0 0-10.26.048l-7.186 7.186a7.176 7.176 0 0 0 10.149 10.149c.142-.142.478-.485.9-.914a12.248 12.248 0 0 1-.54-2.79Z"
    />
    <path
      d="M16.926 20.056a3.579 3.579 0 0 1-.594-.478 4.159 4.159 0 0 1-1.241-1.625 2.041 2.041 0 0 0-.428.318l-1.636 1.712a7.164 7.164 0 0 0 1.227 1.673 6.115 6.115 0 0 0 1.3.97 12.271 12.271 0 0 1 1.372-2.57ZM23.722 6.479a4.1 4.1 0 1 1 5.8 5.8L27 14.8a12.292 12.292 0 0 1 3.759.59l.938-.937A7.176 7.176 0 0 0 21.547 4.3c-.385.385-4.264 4.222-5.351 5.309a8.3 8.3 0 0 1 3.742.607c.521-.516 3.569-3.522 3.784-3.737ZM20.98 24.646c-.582-2.107.921-3.013.772-4.813A8.941 8.941 0 0 0 18.118 27c0 5.069 4.418 8.089 7.539 8.751a3.836 3.836 0 0 0 .581.092c1.113-2.837-.986-6-2.371-8.062-1.153-1.716-2.201-.655-2.887-3.135Z"
    />
    <path
      d="M35.24 27.573c-.9-.341-1.664.821-1.732-2.316a3.206 3.206 0 0 1 .927-2.225 1.718 1.718 0 0 1 .405-.194 9.09 9.09 0 0 0-.345-.566c-.021.011-.039.025-.061.035-.7.324-.792.42-1.112 0a.877.877 0 0 1 .192-1.294 8.892 8.892 0 0 0-6.482-2.9c1.128.015 2.473.851 1.787 2.185.1-.212-2.24-.718-2.559-.718-.429 0 .877-1.607.757-1.468a8.946 8.946 0 0 0-3.68.791c.608.393 1.286.256 1.971.425.147.017.2.05 0 0-1.011-.117.489 2.657.433 2.288a1.281 1.281 0 0 1 2.54-.082 2.082 2.082 0 0 1-.466 1.26c-.785 1.031-.944 2.867-1.335 2.4-3.666-1.5-3.262.484-2.059 1.812 1.926 2.125.949.218 3.472 1.33 2.029.895 4.471 1.106 3.875 1.781-1.8 2.042-1.424 3.395-4.613 5.787a18.738 18.738 0 0 0 1.285-.12 9.052 9.052 0 0 0 7.44-8.011 1.336 1.336 0 0 1-.64-.2Z"
    />
  </svg>`;
};
